import { getAllProductsAndVariantService } from "../services/productService";

export async function getAllProductsAndVariants({
  limit = "",
  page = "",
  minPrice = 0,
  maxPrice = 200000,
  condition = [],
  brand = [],
  isAuction,
  sortBy = "newest",
  categoryId = null,
  k = null
} = {}) {

  try {
    const filters = {
      price: { min: minPrice, max: maxPrice },
      condition,
      brand
    };

    // Only add isAuction if it's not undefined or null
    if (typeof isAuction === "boolean") {
      filters.isAuction = isAuction;
    }

    const res = await getAllProductsAndVariantService({
            "limit": limit,
            "page": page,
            "filters": {...filters},
            "sortBy": sortBy,
            "categoryId": categoryId,
            "k": k
        });
    
    return res;
    
  } catch (error) {
    let message = "An error has occurred.";
    if (error.message) {
      message = error.message;
      console.log("Error message in getAllProductsAndVariants:", message);
    }
    return "";
  }
}
